/*
 *
 * Equal Employment Opportunity (EEO) APIs
 *
 * */

window.EEOAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    /***
     * GET Brand Document (Plain)
     *
     * @returns {deferred.promise|{then, always}}
     */
    self.getBrandDocument = function(brandId,documentType){
        var deferred = $q.defer();

        _protected.request("brand_documents/"+brandId+"/"+documentType, 'GET')
            .then(function(res) {
                if (!res.data || !res.data.data || res.data.status_code != 200) {
                    deferred.reject(res);
                }else{
                    deferred.resolve(res.data.data);
                }
            });

        return deferred.promise;
    }


    /***
     * Save EEO
     *
     * @param data
     * @returns {deferred.promise|{then, always}}
     */
    self.saveBrandDocument = function(brandId, documentType, documentData){
        var deferred = $q.defer();

        var requestPayload = {
            metadata : documentData
        };

        _protected.request("brand_documents/"+brandId+"/"+documentType, 'PUT', requestPayload)
            .then(function(res) {
                if (!res.data || !res.data.data || res.data.status_code != 200) {
                    deferred.reject(res);
                }else{
                    deferred.resolve(res.data.data);
                }

            });

        return deferred.promise;
    }

    self.getEeoFormQuestionsSettings = async (brandId, serviceCode) => {
        const response = await _protected.request(`brands/${brandId}/services/${serviceCode}/forms`, 'GET');

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.updateEeoFormQuestionsSettings = async (brandId, serviceCode, params) => {
        const response = await _protected.request(`brands/${brandId}/services/${serviceCode}/forms`, 'PATCH', params);

        if (response?.status === 200 && response?.data) {
            return response.data;
        }

        throw response;
    };

    self.getEeoQuestionsCandidateSettings = async (brandId, serviceCode, params) => {
        const response = await _protected.request(`brands/${brandId}/services/${serviceCode}/forms/questions/answer`, 'GET', params);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.updateEeoQuestionsCandidateSettings = async (brandId, serviceCode, payload) => {
        const response = await _protected.request(`brands/${brandId}/services/${serviceCode}/forms/questions/answer`, 'POST', payload);

        if (response?.status === 200 && response?.data) {
            return response.data;
        }

        throw response;
    };
});

/**
 * [document type]
 */
EEOAPI.JOB_CATEGORIES = {
    SENIOR_OFFICIALS_AND_MANAGERS: {
        name: $filter("translate")("Executive Senior Level officials and managers"),
        code: "1.1"
    },
    MID_OFFICIALS_AND_MANAGERS: {
        name: $filter("translate")("First/Mid level officials and managers"),
        code: "1.2"
    },
    PROFESSIONALS: {
        name: $filter("translate")("Professionals"),
        code: "2"
    },
    TECHNICIANS: {
        name: $filter("translate")("Technicians"),
        code: "3"
    },
    SALES_WORKERS: {
        name: $filter("translate")("Sales Workers"),
        code: "4"
    },
    ADMINISTRATIVE_SUPPORT: {
        name: $filter("translate")("Administrative Support workers"),
        code: "5"
    },
    CRAFT_WORKERS: {
        name: $filter("translate")("Craft workers"),
        code: "6"
    },
    OPERATIVES: {
        name: $filter("translate")("Operatives"),
        code: "7"
    },
    LABORERS_AND_HELPERS: {
        name: $filter("translate")("Laborers and Helpers"),
        code: "8"
    },
    SERVICE_WORKERS: {
        name: $filter("translate")("Service workers"),
        code: "9"
    }
};

/* EEO Types */
EEOAPI.EEO_TYPES = {
    HL_M: {
        name: $filter("translate")("Male")
    },
    HL_F: {
        name: $filter("translate")("Female")
    },
    NHL_M_WHITE: {
        name: $filter("translate")("White")
    },
    NHL_M_BLACK_OR_AFRICAN_AMERICAN: {
        name: $filter("translate")("Black or African American")
    },
    NHL_M_NATIVE_HAWAIIAN_OR_PACIFIC_ISLANDER: {
        name: $filter("translate")("Native Hawaiian or Other Pacific Islander")
    },
    NHL_M_ASIAN: {
        name: $filter("translate")("Asian")
    },
    NHL_M_AMERICAN_INDIAN_OR_ALASKA_NATIVE: {
        name: $filter("translate")("American Indian or Alaska Native")
    },
    NHL_M_TWO_OR_MORE_RACES: {
        name: $filter("translate")("Two or more races")
    },
    NHL_F_WHITE: {
        name: $filter("translate")("White")
    },
    NHL_F_BLACK_OR_AFRICAN_AMERICAN: {
        name: $filter("translate")("Black or African American")
    },
    NHL_F_NATIVE_HAWAIIAN_OR_PACIFIC_ISLANDER: {
        name: $filter("translate")("Native Hawaiian or Other Pacific Islander")
    },
    NHL_F_ASIAN: {
        name: $filter("translate")("Asian")
    },
    NHL_F_AMERICAN_INDIAN_OR_ALASKA_NATIVE: {
        name: $filter("translate")("American Indian or Alaska Native")
    },
    NHL_F_TWO_OR_MORE_RACES: {
        name: $filter("translate")("Two or more races")
    }
};